import { AirFilterIcon } from './AirFilterIcon';

/**
 * author: Michael Irigoyen
 * id C9AF90F5-7CE7-4251-9BA2-3A614B4882AA
 * name air-filter
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/air-filter.svg
 * tags
 * - Home Automation 
 */
export const WaterFilterIcon = AirFilterIcon;
export default WaterFilterIcon